<app-versatile-list>
    <app-versatile-list-header [isLoading]="isLoading">
        <ng-container *ngIf="!isLoading && (headerTitle || headerSubtitle); else headerPlaceholder">
            <div class="header-content">
                <app-scroll-list-item
                    [title]="headerTitle"
                    [subtitle]="headerSubtitle"
                    [description]="headerDescription"
                    [leftIcon]="headerLeftIcon"
                    [selected]="false"
                    [highlighted]="false">
                </app-scroll-list-item>
                <div class="header-actions">
                    <ng-content select="[recipeHeaderActions]"></ng-content>
                </div>
            </div>
        </ng-container>
        <ng-template #headerPlaceholder>
            <div class="header-placeholder">
                <div class="title">{{ resolvedPlaceholderTitle }}</div>
                <div class="subtitle">{{ resolvedPlaceholderSubtitle }}</div>
            </div>
        </ng-template>
    </app-versatile-list-header>

    <app-versatile-list-body
        [items]="internalItems"
        [total]="internalItems?.length || 0"
        [isLoading]="isLoading">
        <ng-template versatileListItem let-item let-index="index">
            <app-sample-board-recipe-item
                class="list__item"
                [item]="item"
                [index]="index"
                (openMaterial)="onOpenMaterial($event)">
            </app-sample-board-recipe-item>
        </ng-template>

        <ng-container versatileListEmpty>
            <app-empty-state
                icon="fa-square-o"
                [text]="(i18nKey + '.empty') | translate">
            </app-empty-state>
        </ng-container>
    </app-versatile-list-body>

    <app-versatile-list-footer [isLoading]="isLoading">
        <ng-container *ngIf="!isLoading">
            <div class="footer-info">
                <div class="footer-title">{{ footerTitle }}</div>
                <div class="footer-meta">{{ footerSubtitle }}</div>
            </div>
            <div class="footer-actions" *ngIf="hasFooterActions || canUploadConstruction">
                <ng-content select="[recipeFooterActions]"></ng-content>
                <ng-container *ngIf="canUploadConstruction">
                    <app-button *ngIf="!hasConstructionInstructions"
                                type="primary"
                                icon="fa-upload"
                                [disabled]="isSavingConstructionInstructions"
                                (clicked)="onUploadClick()">
                        {{ 'admin.strain.sample-boards.details.tabs.documentation.recipe.actions.uploadConstructionInstructions' | translate }}
                    </app-button>
                    <ng-container *ngIf="hasConstructionInstructions">
                        <app-icon type="info"
                                  library="fontawesome"
                                  variant="fa-refresh"
                                  (click)="onUploadClick()">
                        </app-icon>
                        <app-button type="primary"
                                    icon="fa-download"
                                    [disabled]="isDownloadingConstructionInstructions"
                                    (clicked)="onDownload()">
                            {{ 'admin.strain.sample-boards.details.tabs.documentation.recipe.actions.downloadConstructionInstructions' | translate }}
                        </app-button>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
    </app-versatile-list-footer>
</app-versatile-list>

<input #constructionFileInput
       type="file"
       hidden
       (change)="onFileSelected($event)">
